import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0050c4c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0050c4c2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050c4c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0050c4c2')) {
      api.createRecord('0050c4c2', component.options)
    } else {
      api.reload('0050c4c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0050c4c2&scoped=true", function () {
      api.rerender('0050c4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/index.vue"
export default component.exports